import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchTaxonomyAction, FetchUserInfoAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner } from "pepsico-ds";
import { Outlet, useNavigate } from "react-router-dom";
import { call7DaysNpsLogic } from '../../utils/utils';

import LandingPageHeader from "../../components/Header/LandingPageHeader";
import MainHeader from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import TaxonomyBanner from '../../assets/TaxonomyBanner.svg'
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";

import Taxonomy_Training from '../../assets/Taxonomy_Training.svg'
import Taxonomy_Mapping from '../../assets/Taxonomy_Mapping.svg'
import Taxonomy_Overview from '../../assets/Taxonomy_Overview.svg'
import Taxonomy_Additional from '../../assets/Taxonomy_Additional.svg'
import Taxonomy_Intake from '../../assets/Taxonomy_Intake.svg'
import TaxonomyCard from "../../components/Cards/TaxonomyCard";

import { Layout, Row, Col } from "antd";

const { Content } = Layout;

function TaxonomyScreen() {
	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
	
	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchUserInfoAction(user));
			}
		}
		fetchUserInfo();
	}, []);

	const userData = useSelector(state => state.getUserInfoReducer);
	const resourcesData = useSelector(state => state.getTaxonomyReducer);

    const cards = [
        {
        courseName: "Training Resources", 
        image: Taxonomy_Training, 
        buttons: [],
        key: "Training Resources"
		},
        {
        courseName: "Mapping Resources", 
        image: Taxonomy_Mapping, 
        buttons: [],
        key: "Mapping Resources"
		},
        {
        courseName: "Taxonomy Overview", 
        image: Taxonomy_Overview, 
        buttons: [],
        key: "Taxonomy Overview"
		},
        {
        courseName: "Additional Resources", 
        image: Taxonomy_Additional,  
        buttons: [],
        key: "Additional Resources"
		},
        {
        courseName: "Intake Request", 
        image: Taxonomy_Intake,  
        buttons: [],
        key: "Intake Request"
		},
    ];
    
	const [cardsData, setCardsData] = useState([]);
	
    /* istanbul ignore next */
    useEffect(() => {
        if (userData && userData.type === "SUCCESS_USER_INFO_ACTION") {
          call7DaysNpsLogic(dispatch, userData);
          dispatch(FetchTaxonomyAction());
        }
      }, [userData]);
      
    /* istanbul ignore next */
    useEffect(() => {
        if (resourcesData && resourcesData.type === "SUCCESS_TAXONOMY_DATA_ACTION") {
            console.log(resourcesData);

            const populatedConfigs = cards.map(config => {
                const links = resourcesData[config.key] || [];
                
                return {
                  ...config,
                  buttons: links.map(linkItem => ({
                    name: linkItem.name,
                    url: linkItem.url,
                    // disabled: linkItem.name.toLowerCase().includes("coming soon") 
                  }))
                };
            });
            setCardsData(populatedConfigs)
        }
      }, [resourcesData]);

	if(authState?.isAuthenticated){
		return(
			
                <>
                    <Layout>
                        <div style={{ display: "flex", background: "#D7E5F8" }}> 
                            <Content style={{ padding: '0 30px 30px 100px', background: '#D7E5F8', minHeight:"125vh" }}>
                                {(userInfo && Object.keys(userInfo).length === 0) || (cardsData && cardsData.length===0) ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 'calc(100vh - 64px)' }}>
                                        <LoadingSpinner
                                            size={{
                                                height: '80px',
                                                width: '80px'
                                            }}
                                        />
                                    </div>
                                    : 
                                        <div style={{}}>
                                            <CommodityPageHeader header={"Procurement Taxonomy 2.0"}
                                                subtext={"This page provides a single starting point for onboarding, training, governance, and reference materials for Procurement Taxonomy 2.0."}
                                                image={TaxonomyBanner}/>

                                            <Row gutter={[20, 20]}>
                                                {cardsData.map((item) => (
                                                        <Col key={item.id} xs={24} sm={24} md={12} lg={6} xl={6}>
                                                            <TaxonomyCard card={item}/>
                                                        </Col>
                                                ))}

                                            </Row>    
                                        </div>
                                    }
                            </Content>
					    </div>
				    </Layout>
				</>
                    
		)
	}
}

export default TaxonomyScreen;